<template>
    <div class="row">
        <div class="col-md-4 col-sm-6 mb-4 position-relative" v-for="(module, index) in modules" :key="`card-module-${module.id}${index}`">
            <div class="module-card-compact">
                <div class="module-image-container">
                    <b-skeleton-img
                        v-if="loaded.indexOf(module.id) < 0"
                        style="aspect-ratio: 320 / 480;"
                    />
                    <img v-show="loaded.indexOf(module.id) > -1" 
                         :src="module.imgUrl" 
                         alt="Imagem do módulo"
                         class="module-image-compact"
                         @load="loaded.push(module.id)">
                    
                    <div class="module-overlay-compact">
                        <div class="module-title-overlay" v-if="module.show_title">
                            <h4>{{ module.title }}</h4>
                        </div>
                        <div class="module-progress-overlay">
                            <div class="progress-circle-compact">
                                <svg class="progress-ring-compact" width="50" height="50">
                                    <circle class="progress-ring-circle-compact" 
                                            cx="25" cy="25" r="20" 
                                            :stroke-dasharray="circumferenceCompact"
                                            :stroke-dashoffset="getProgressOffsetCompact(module.progress)">
                                    </circle>
                                </svg>
                                <span class="progress-text-compact">{{ Math.round(module.progress) }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="module-content-compact">
                    <div class="module-header-compact">
                        <h5 class="module-name-compact">{{ module.title }}</h5>
                        <div class="module-status-compact" :class="getModuleStatusClass(module.progress)">
                            <i :class="getModuleStatusIcon(module.progress)"></i>
                        </div>
                    </div>
                    
                    <div class="module-progress-section-compact">
                        <div class="progress-bar-module-compact">
                            <div class="progress-fill-compact" :style="`width: ${module.progress}%;`"></div>
                        </div>
                        <span class="progress-value-compact">{{ Math.round(module.progress) }}%</span>
                    </div>
                    
                    <div class="module-tasks-section-compact">
                        <div class="tasks-header-compact" @click="toggleModule(module.id)">
                            <div class="tasks-info-compact">
                                <span class="tasks-count-compact">{{ module.tasks ? module.tasks.length : 0 }} tarefas</span>
                                <span class="pendencies-badge-compact" :class="getPendenciesClass(module.pendencies)">
                                    {{ module.pendencies || 0 }}
                                </span>
                            </div>
                            <i class="toggle-icon-compact" :class="isOpen.indexOf(module.id) > -1 ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </div>
                        
                        <b-collapse :id="`collapse-${module.id}`" 
                                    @shown="isOpen.push(module.id)"
                                    @hidden="closeCollapse(module.id)">
                            <div class="tasks-list-compact">
                                <div class="task-item-compact" 
                                     v-for="task in module.tasks" 
                                     :key="`task-${task.id}`"
                                     :class="getTaskStatusClass(task.status)"
                                     @click="viewResponse(task)">
                                    <div class="task-content-compact">
                                        <span class="task-title-compact">{{ task.contents.subject }}</span>
                                        <span class="task-type-compact">{{ getTaskTypeText(task.contents.type) }}</span>
                                    </div>
                                    <div class="task-status-compact">
                                        <i :class="getTaskStatusIcon(task.status)"></i>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    props: {
        modules: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            show_details: false,
            color: null,
            mouseOn: false,
            loaded: [],
            isOpen: [],
            mentoring: this.$route.params.mentoring,
            mentee: this.$route.params.mentee,
            circumference: 2 * Math.PI * 25, // Para o círculo de progresso
            circumferenceCompact: 2 * Math.PI * 20 // Para o círculo de progresso compacto
        }
    },

    methods: {
        viewResponse(task) {
            // Emitir evento para abrir modal com o conteúdo da atividade
            this.$emit('view-activity', task);
        },
        closeCollapse(id) {
            let index = -1;
            this.isOpen.forEach((el, i) => {
                if (el === id) index = i;
            })

            if (index > -1) this.isOpen.splice(index, 1);
        },
        editModule(indexModule) {
            this.$emit('edit-module', indexModule);
        },

        toggleModule(moduleId) {
            this.$root.$emit('bv::toggle::collapse', `collapse-${moduleId}`);
        },

        getProgressOffset(progress) {
            const offset = this.circumference - (progress / 100) * this.circumference;
            return offset;
        },

        getProgressOffsetCompact(progress) {
            const offset = this.circumferenceCompact - (progress / 100) * this.circumferenceCompact;
            return offset;
        },

        getModuleStatusClass(progress) {
            if (progress >= 100) return 'status-completed';
            if (progress >= 80) return 'status-excellent';
            if (progress >= 60) return 'status-good';
            if (progress >= 40) return 'status-average';
            return 'status-poor';
        },

        getModuleStatusIcon(progress) {
            if (progress >= 100) return 'fas fa-check-circle';
            if (progress >= 80) return 'fas fa-star';
            if (progress >= 60) return 'fas fa-thumbs-up';
            if (progress >= 40) return 'fas fa-clock';
            return 'fas fa-exclamation-triangle';
        },

        getModuleStatusText(progress) {
            if (progress >= 100) return 'Concluído';
            if (progress >= 80) return 'Excelente';
            if (progress >= 60) return 'Bom';
            if (progress >= 40) return 'Em andamento';
            return 'Precisa atenção';
        },

        getPendenciesClass(pendencies) {
            if (!pendencies || pendencies === 0) return 'badge-success';
            if (pendencies <= 2) return 'badge-warning';
            return 'badge-danger';
        },

        getTaskStatusClass(status) {
            if (status === 3) return 'task-completed';
            if (status === 2) return 'task-pending';
            if (status === 1) return 'task-waiting';
            return 'task-waiting';
        },

        getTaskStatusIcon(status) {
            if (status === 3) return 'fas fa-check-circle';
            if (status === 2) return 'fas fa-exclamation-circle';
            if (status === 1) return 'fas fa-clock';
            return 'fas fa-clock';
        },

        getTaskTypeText(type) {
            const types = {
                3: 'Formulário',
                4: 'Atividade',
                5: 'Agenda'
            };
            return types[type] || 'Tarefa';
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR');
        }
    },

    created() {
        this.color = document.getElementById('mentoring_color');
    },
}
</script>

<style scoped>
/* Layout Compacto Similar ao Cadastro */
.module-card-compact {
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    border: 1px solid rgba(0,0,0,0.05);
    transition: all 0.3s ease;
    position: relative;
    height: 100%;
}

.module-card-compact:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

/* Container da Imagem Compacta */
.module-image-container {
    position: relative;
    height: 200px;
    overflow: hidden;
}

.module-image-compact {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.module-card-compact:hover .module-image-compact {
    transform: scale(1.05);
}

/* Overlay da Imagem Compacta */
.module-overlay-compact {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem;
}

.module-title-overlay h4 {
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.module-progress-overlay {
    display: flex;
    justify-content: flex-end;
}

/* Círculo de Progresso Compacto */
.progress-circle-compact {
    position: relative;
    width: 50px;
    height: 50px;
}

.progress-ring-compact {
    transform: rotate(-90deg);
}

.progress-ring-circle-compact {
    fill: transparent;
    stroke: rgba(255,255,255,0.3);
    stroke-width: 3;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.5s ease;
}

.progress-ring-circle-compact {
    stroke: #28a745;
}

.progress-text-compact {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-weight: 700;
    font-size: 0.8rem;
    text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

/* Conteúdo Compacto */
.module-content-compact {
    padding: 1rem;
}

.module-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}

.module-name-compact {
    font-size: 1rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
    flex: 1;
    line-height: 1.2;
}

.module-status-compact {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 0.8rem;
}

.status-completed {
    background: #d4edda;
    color: #155724;
}

.status-excellent {
    background: #cce5ff;
    color: #004085;
}

.status-good {
    background: #d1ecf1;
    color: #0c5460;
}

.status-average {
    background: #fff3cd;
    color: #856404;
}

.status-poor {
    background: #f8d7da;
    color: #721c24;
}

/* Seção de Progresso Compacta */
.module-progress-section-compact {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.progress-bar-module-compact {
    flex: 1;
    height: 6px;
    background: #f8f9fa;
    border-radius: 10px;
    overflow: hidden;
}

.progress-fill-compact {
    height: 100%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    border-radius: 10px;
    transition: width 0.6s ease;
}

.progress-value-compact {
    font-size: 0.8rem;
    font-weight: 700;
    color: #2c3e50;
    min-width: 35px;
    text-align: right;
}

/* Seção de Tarefas Compacta */
.module-tasks-section-compact {
    border-top: 1px solid #f8f9fa;
    padding-top: 0.75rem;
}

.tasks-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background 0.3s ease;
}

.tasks-header-compact:hover {
    background: #f8f9fa;
}

.tasks-info-compact {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.tasks-count-compact {
    font-size: 0.8rem;
    color: #7f8c8d;
    font-weight: 500;
}

.pendencies-badge-compact {
    padding: 0.125rem 0.5rem;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: 700;
    min-width: 20px;
    text-align: center;
}

.badge-success {
    background: #d4edda;
    color: #155724;
}

.badge-warning {
    background: #fff3cd;
    color: #856404;
}

.badge-danger {
    background: #f8d7da;
    color: #721c24;
}

.toggle-icon-compact {
    color: #7f8c8d;
    font-size: 0.8rem;
    transition: transform 0.3s ease;
}

.tasks-header-compact:hover .toggle-icon-compact {
    color: #667eea;
}

/* Lista de Tarefas Compacta */
.tasks-list-compact {
    margin-top: 0.75rem;
    border-radius: 8px;
    overflow: hidden;
}

.task-item-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    border-bottom: 1px solid #f8f9fa;
    cursor: pointer;
    transition: all 0.3s ease;
}

.task-item-compact:last-child {
    border-bottom: none;
}

.task-item-compact:hover {
    background: #f8f9fa;
    transform: translateX(3px);
}

.task-content-compact {
    flex: 1;
    min-width: 0;
}

.task-title-compact {
    font-weight: 600;
    color: #2c3e50;
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.85rem;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.task-type-compact {
    background: #e9ecef;
    padding: 0.125rem 0.375rem;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.7rem;
    color: #6c757d;
}

.task-status-compact {
    font-size: 1rem;
    margin-left: 0.75rem;
    flex-shrink: 0;
}

.task-completed {
    background: #d4edda;
    border-left: 3px solid #28a745;
    color: #28a745;
}

.task-pending {
    background: #fff3cd;
    border-left: 3px solid #ffc107;
    color: #856404;
}

.task-waiting {
    background: #e2e3e5;
    border-left: 3px solid #6c757d;
    color: #6c757d;
}

/* Responsividade */
@media (max-width: 768px) {
    .module-image-container {
        height: 180px;
    }
    
    .module-content-compact {
        padding: 0.75rem;
    }
    
    .module-name-compact {
        font-size: 0.9rem;
    }
    
    .tasks-header-compact {
        padding: 0.375rem;
    }
    
    .task-item-compact {
        padding: 0.5rem;
    }
}

@media (max-width: 576px) {
    .module-image-container {
        height: 160px;
    }
    
    .module-overlay-compact {
        padding: 0.75rem;
    }
    
    .module-title-overlay h4 {
        font-size: 1rem;
    }
    
    .module-content-compact {
        padding: 0.1rem;
    }
    
    .progress-circle-compact {
        width: 40px;
        height: 40px;
    }
    
    .progress-ring-compact {
        width: 40px;
        height: 40px;
    }
    
    .progress-ring-circle-compact {
        cx: 20;
        cy: 20;
        r: 16;
    }
    
    .progress-text-compact {
        font-size: 0.7rem;
    }
}

/* Animações */
@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.module-card-compact {
    animation: slideInUp 0.5s ease-out;
}

.module-card-compact:nth-child(1) { animation-delay: 0.1s; }
.module-card-compact:nth-child(2) { animation-delay: 0.2s; }
.module-card-compact:nth-child(3) { animation-delay: 0.3s; }
.module-card-compact:nth-child(4) { animation-delay: 0.4s; }
.module-card-compact:nth-child(5) { animation-delay: 0.5s; }
.module-card-compact:nth-child(6) { animation-delay: 0.6s; }

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

.module-card-compact:hover .progress-circle-compact {
    animation: pulse 2s infinite;
}
</style>
